import React, { useState,useEffect } from 'react';
import classNames from 'classnames';
import { useSelector, useDispatch } from 'react-redux';
import styles from './CustomAlert.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faClose,faQuestionCircle} from '@fortawesome/free-solid-svg-icons';
import { setAlertInfo } from '../../store/CustomViewSlice';
export function CustomAlert(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    // 在这里执行你的组件挂载后的逻辑
    // 这里可以返回一个清理函数，它会在组件卸载前执行
    return () => {
        // console.log('组件即将卸载');
    };
  }, []); // 空数组意味着这个 effect 只会在组件挂载时执行一次
  function confirmMethod(params) {
    dispatch(setAlertInfo({
        showStatus:false,
        title:"",
        title1:"",
        content:""
    }))
  }


  return (
    props.info.showStatus?
        <div className={styles.background}>
          <div className={styles.container}>
            <div className={styles.topBar}>
                <div className={classNames(styles.topTitle,styles.scrollable)}>{props.info.title==""?"温馨提示":props.info.title}</div>
                <div className={styles.topCancelButton}>
                    <FontAwesomeIcon 
                        icon={faClose}
                        onClick={(e)=>{
                            // dispatch(setShowAddInfoPage(false))
                            confirmMethod()
                        }}
                    />
                </div>
                
            </div>
            <div className={styles.middleContainer}>
                <FontAwesomeIcon 
                    className={styles.questionIcon}
                    icon={faQuestionCircle}
                    onClick={(e)=>{
                        // dispatch(setShowAddInfoPage(false))
                    }}
                />
                <div className={styles.middleRightContainer}>
                    <div className={classNames(styles.middleTitle,styles.scrollable)}>
                        {props.info.title1}
                    </div>
                    <div className={classNames(styles.middleContent,styles.scrollable)}>
                        {props.info.content}
                    </div>
                </div>
            </div>
            <div className={styles.bottomContainer}>
                {/* <div className={styles.cancelButton}
                    onClick={(e)=>{
                        props.cancelMethod()
                    }}
                >取消</div> */}
                <div className={styles.confirmButton}
                    onClick={(e)=>{
                        // dispatch(setShowAddInfoPage(false))
                        confirmMethod()
                    }}
                >确定</div>
            </div>
          </div>
        </div>:null
        )
}
